/**
 * Utilitaire pour améliorer l'accessibilité de MTCaptcha
 * Ajoute les attributs title manquants aux iframes
 */

export const enhanceMTCaptchaAccessibility = () => {
  // Observer pour détecter l'injection de l'iframe MTCaptcha
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const element = node as Element;
          
          // Trouver tous les iframes MTCaptcha
          const mtcaptchaIframes = element.querySelectorAll('iframe[src*="mtcaptcha"]');
          mtcaptchaIframes.forEach((iframe: Element) => {
            const iframeElement = iframe as HTMLIFrameElement;
            if (!iframeElement.hasAttribute('title')) {
              iframeElement.setAttribute('title', 'MTCaptcha verification widget');
              iframeElement.setAttribute('aria-label', 'Security verification');
            }
          });
          
          // Vérifier si l'élément lui-même est un iframe MTCaptcha
          if (element.tagName === 'IFRAME' && element.getAttribute('src')?.includes('mtcaptcha')) {
            const iframeElement = element as HTMLIFrameElement;
            if (!iframeElement.hasAttribute('title')) {
              iframeElement.setAttribute('title', 'MTCaptcha verification widget');
              iframeElement.setAttribute('aria-label', 'Security verification');
            }
          }
        }
      });
    });
  });
  
  // Observer le body pour les changements
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Également vérifier les iframes existants
  const checkExistingIframes = () => {
    const mtcaptchaIframes = document.querySelectorAll('iframe[src*="mtcaptcha"]');
    mtcaptchaIframes.forEach((iframe: Element) => {
      const iframeElement = iframe as HTMLIFrameElement;
      if (!iframeElement.hasAttribute('title')) {
        iframeElement.setAttribute('title', 'MTCaptcha verification widget');
        iframeElement.setAttribute('aria-label', 'Security verification');
      }
    });
  };
  
  // Vérifier immédiatement et après chargement
  checkExistingIframes();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkExistingIframes);
  }
  
  // Vérifier également après un délai pour les iframes chargés dynamiquement
  setTimeout(checkExistingIframes, 1000);
  setTimeout(checkExistingIframes, 3000);
  
  return () => {
    observer.disconnect();
  };
};
